// extracted by mini-css-extract-plugin
export default {"title":"LandingPage_title__tN7CS","name":"LandingPage_name__t3yTV"};